<script setup lang="ts" generic="T, MM">
import { useQuery } from '@vue/apollo-composable'
import gql from 'graphql-tag'
import SelectField from '@/components/input/SelectField.vue'
import { computed, watch } from 'vue'
import { itemSortByName } from '@/app'
import { ProductPickerDataQuery, ProductPickerDataQueryVariables } from '@/generated/graphql'

const model = defineModel<string | undefined>()
const props = defineProps<{
  withArchived?: boolean
}>()
const fetchQuery = useQuery<ProductPickerDataQuery, ProductPickerDataQueryVariables>(gql`
  query ProductPickerData {
    product {
      products {
        id
        name
        archived
      }
    }
  }
`)
const options = computed(() =>
  itemSortByName(
    fetchQuery.result.value?.product.products.filter((p) => props.withArchived || !p.archived),
    (c) => c.name,
  ).map((c) => ({
    title: c.name,
    value: c.id,
  })),
)
watch(options, (v) => {
  if (v.length == 1) {
    model.value = v[0].value
  }
  if (v.length == 0) {
    model.value = undefined
  }
})
</script>

<template>
  <select-field v-model="model" :items="options" />
</template>

<style scoped lang="scss"></style>
